<div class="dz-flex dz-align-items-center dz-justify-content-evenly padding-layout-6 no-model-class">
	<dz-pictogram name="risk" size="200"></dz-pictogram>
	<h2 class="dz-text-24-bold padding-object-2" [dcrHTMLKey]="titleDCR || 'EMPTY_MODEL_LIST_TEXT_1'">There are no models available</h2>
	<p class="dz-text-16 padding-object-1" [dcrHTMLKey]="subTextDCR || 'EMPTY_MODEL_LIST_TEXT_2'">based on your filter selections. Please select another filters</p>
</div>
